// 관리자 API 호출 헬퍼.
//
// /api/admin/** 는 ADMIN 등급만 통과한다(SecurityConfig). 토큰을 싣지 않으면
// 401 이 돌아오고 화면이 빈 채로 뜬다. 관리자 화면의 fetch 는 전부 이걸 쓴다.

/** localStorage 의 JWT 를 Authorization 헤더에 붙여 fetch 한다. */
export const adminFetch = (url, options = {}) => {
    const token = localStorage.getItem("token");
    const headers = { ...(options.headers || {}) };
    if (token) headers.Authorization = `Bearer ${token}`;
    return fetch(url, { ...options, headers });
};

/**
 * 실패 응답을 사람이 읽을 메시지로 바꾼다.
 * 401 과 403 은 원인이 달라서 — 로그인을 안 했는지, 등급이 모자라는지 —
 * 같은 문구로 뭉뚱그리면 뭘 해야 할지 알 수 없다.
 */
export const adminErrorMessage = async (res) => {
    if (res.status === 401) return "로그인이 필요합니다. 관리자 계정으로 로그인해 주세요.";
    if (res.status === 403) return "관리자 권한이 없는 계정입니다.";
    try {
        const body = await res.json();
        return body.message || `요청이 실패했습니다. (${res.status})`;
    } catch {
        return `요청이 실패했습니다. (${res.status})`;
    }
};
